import DateInput from '../DateInput/DateInput';

const DateRangeFilter = ({from, to, onChange}) => (
    <section className="filter-card">
        <div className="filter-card__header">
            <div className="filter-card__title">Date range</div>
        </div>
        <div className="filter-row">
            <label className="filter-label">From</label>
            <DateInput
                value={from}
                max={to ?? undefined}
                className="filter-date-input"
                onChange={v => onChange({from: v, to})}
            />
        </div>
        <div className="filter-row">
            <label className="filter-label">To</label>
            <DateInput
                value={to}
                min={from ?? undefined}
                className="filter-date-input"
                onChange={v => onChange({from, to: v})}
            />
        </div>
    </section>
);

export default DateRangeFilter;
